module.exports = __webpack_public_path__ + "img/42_16.375ef672.png";